export default "__VITE_ASSET__a58f4125__"